{
  "CONTENT_SLUG_INVALID": "Slug deve conter apenas letras minúsculas, números e hífens",
  "CONTENT_LINK_NOT_FOUND": "Vínculo não encontrado",
  "PRODUCT_NOT_FOUND": "Produto não encontrado",
  "PRODUCT_ARCHIVED_NOT_FOUND": "Produto arquivado não encontrado",
  "PRODUCT_SLUG_TAKEN": "Já existe um produto com este slug",
  "PRODUCT_STATUS_INVALID": "Status deve ser DRAFT, PUBLISHED ou ARCHIVED",
  "PRODUCT_TARGET_COURSE_NOT_FOUND": "Curso de destino não encontrado",
  "PRODUCT_DELETED": "Produto excluído com sucesso",
  "PRODUCT_DRAFTS_DELETED": "{{count}} curso(s) rascunho excluído(s) com sucesso",
  "PRODUCT_CONVERTED_TO_MODULE": "Curso \"{{title}}\" convertido em módulo com {{count}} aulas",
  "PRODUCT_MERGED_TO_COURSE": "{{count}} curso(s) convertido(s) em módulos de \"{{title}}\"",
  "CMS_PAGE_NOT_FOUND": "Página não encontrada",
  "CMS_PAGE_SLUG_TAKEN": "Já existe uma página com este slug",
  "CMS_PAGE_DELETED": "Página excluída com sucesso",
  "CMS_SECTION_NOT_FOUND": "Seção não encontrada",
  "CMS_SECTION_IDENTIFIER_TAKEN": "Já existe uma seção com este identificador nesta página",
  "CMS_SECTION_DELETED": "Seção excluída com sucesso",
  "CMS_BLOCK_NOT_FOUND": "Bloco não encontrado",
  "CMS_BLOCK_DELETED": "Bloco excluído com sucesso",
  "CMS_TEMPLATE_NOT_FOUND": "Template não encontrado",
  "CMS_COMPONENT_NOT_FOUND": "Componente não encontrado",
  "CERTIFICATE_NOT_FOUND": "Certificado não encontrado",
  "CERTIFICATE_REVOKED": "Certificado revogado",
  "CERTIFICATE_TEMPLATE_NOT_FOUND": "Template não encontrado",
  "CERTIFICATE_TEMPLATE_DEFAULT_NOT_DELETABLE": "Não é possível excluir o template padrão",
  "CERTIFICATE_TEMPLATE_IN_USE": "Este template está sendo usado por {{count}} certificado(s)",
  "CERTIFICATE_TEMPLATE_DELETED": "Template excluído com sucesso",
  "CERTIFICATE_PRODUCT_NOT_COMPLETED": "Usuário não completou este produto",
  "CERTIFICATE_USER_OR_PRODUCT_NOT_FOUND": "Usuário ou produto não encontrado",
  "CERTIFICATE_MEMBER_NOT_FOUND": "Membro não encontrado",
  "CERTIFICATE_CONTENT_REQUIRED": "Selecione um conteúdo para emitir",
  "CERTIFICATE_CONTENT_NOT_FOUND": "Conteúdo não encontrado",
  "CUSTOMIZATION_PRIMARY_COLOR_INVALID": "Cor primária deve ser um código hexadecimal válido",
  "CUSTOMIZATION_SECONDARY_COLOR_INVALID": "Cor secundária deve ser um código hexadecimal válido",
  "CUSTOMIZATION_FILE_REQUIRED": "Nenhum arquivo enviado",
  "CUSTOMIZATION_FILE_TYPE_INVALID": "Formatos aceitos: {{formats}}",
  "CUSTOMIZATION_FILE_TOO_LARGE": "Arquivo deve ter no máximo {{max}}MB",
  "PRODUCT_APPEARANCE_COURSE_NOT_FOUND": "Curso não encontrado",
  "PRODUCT_APPEARANCE_SECTION_NOT_FOUND": "Seção não encontrada",
  "PRODUCT_APPEARANCE_SECTION_REMOVED": "Seção removida com sucesso",
  "PRODUCT_APPEARANCE_SECTIONS_REORDERED": "Seções reordenadas com sucesso",
  "PRODUCT_APPEARANCE_MENU_ITEM_NOT_FOUND": "Item de menu não encontrado",
  "PRODUCT_APPEARANCE_MENU_ITEM_REMOVED": "Item de menu removido com sucesso",
  "PRODUCT_APPEARANCE_MENU_REORDERED": "Menu reordenado com sucesso",
  "MEMBER_AREA_NOT_FOUND": "Área de membros não encontrada",
  "MEMBER_AREA_SLUG_TAKEN": "Este slug já está em uso",
  "MEMBER_AREA_INACTIVE": "Esta área de membros não está ativa",
  "MEMBER_AREA_COLOR_INVALID": "Cor deve estar no formato hex (#RRGGBB)",
  "MEMBER_AREA_DELETED": "Área de membros excluída com sucesso",
  "MEMBER_AREA_BANNER_NOT_FOUND": "Banner não encontrado",
  "MEMBER_AREA_BANNER_DELETED": "Banner excluído com sucesso",
  "MEMBER_AREA_BANNERS_REORDERED": "Banners reordenados com sucesso",
  "MEMBER_AREA_MENU_ITEM_NOT_FOUND": "Item de menu não encontrado",
  "MEMBER_AREA_MENU_ITEM_DELETED": "Item de menu excluído com sucesso",
  "MEMBER_AREA_MENU_REORDERED": "Menu reordenado com sucesso",
  "COURSE_SECTION_NOT_FOUND": "Seção com ID {{id}} não encontrada",
  "COURSE_SECTION_SOME_NOT_FOUND": "Uma ou mais seções não existem",
  "COURSE_SECTION_PRODUCT_NOT_FOUND": "Produto com ID {{id}} não encontrado",
  "COURSE_SECTION_PRODUCT_ALREADY_ADDED": "Produto já está nesta seção",
  "COURSE_SECTION_PRODUCT_NOT_IN_SECTION": "Produto não está nesta seção",
  "COURSE_SECTION_PRODUCTS_NOT_IN_SECTION": "Um ou mais produtos não estão nesta seção",
  "CATEGORY_NOT_FOUND": "Categoria não encontrada",
  "CATEGORY_SLUG_TAKEN": "Slug já existe",
  "CATEGORY_DELETED": "Categoria excluída",
  "LEARNING_TRAIL_NOT_FOUND": "Trilha não encontrada",
  "LEARNING_TRAIL_PRODUCTS_NOT_FOUND": "Um ou mais produtos não foram encontrados",
  "LEARNING_TRAIL_UNAVAILABLE": "Esta trilha não está disponível",
  "LEARNING_TRAIL_ALREADY_ENROLLED": "Usuário já matriculado nesta trilha",
  "LEARNING_TRAIL_ENROLLMENT_NOT_FOUND": "Matrícula na trilha não encontrada",
  "MODULE_NOT_FOUND": "Módulo não encontrado",
  "MODULE_PARENT_NOT_FOUND": "Módulo pai não encontrado",
  "MODULE_ALREADY_LINKED": "Módulo já vinculado a este curso",
  "MODULE_SECTION_DELETED": "Seção excluída. Sub-módulos foram desvinculados.",
  "MODULE_CHILDREN_REORDERED": "Sub-módulos reordenados",
  "MODULE_UNLINKED": "Módulo desvinculado do curso",
  "LESSON_NOT_FOUND": "Aula não encontrada",
  "LESSON_ACCESS_DENIED": "Você não tem acesso a esta aula",
  "LESSON_ALREADY_LINKED": "Aula já vinculada a este módulo",
  "LESSON_DELETED": "Aula excluída",
  "LESSON_UNLINKED": "Aula desvinculada do módulo",
  "ANALYTICS_EXPORT_TYPE_INVALID": "Tipo de export inválido",
  "PRODUCT_ACCESS_DENIED": "Você não tem acesso a este curso",
  "PRODUCT_VISIBILITY_INVALID": "Visibilidade deve ser HIDDEN ou LOCKED",
  "CUSTOMIZATION_THEME_INVALID": "Modo de tema deve ser STUDENT_CHOICE, LIGHT ou DARK",
  "LESSON_VIDEO_PROVIDER_INVALID": "Provedor de vídeo deve ser gumlet, youtube, vimeo, panda ou direct",
  "LESSON_VIDEO_URL_INVALID": "Link de vídeo inválido para o provedor escolhido",
  "LESSON_COMPLETION_TRACKED_BY_PLAYER": "Esta aula é concluída automaticamente quando você assiste ao vídeo"
}
